
import { mapState } from 'vuex'
export default {
    name: 'Theme2MissionMobileCreditExchangeRewardTab',
    data() {
        return {
            tab: null,
        }
    },
    computed: {
        ...mapState({
            creditTiers: (state) =>
                state.activities['exchange-reward'].creditTiers,
            rewards: (state) => state.activities['exchange-reward'].rewards,
            vipTiers: (state) => state.activities['vip-system'].vipTiers,
            rewardsLoading: (state) =>
                state.activities['exchange-reward'].rewardsLoading,
            defaultCurrency: (state) => state.settings.defaultCurrency,
        }),
        rewardsById() {
            return (v) => {
                return this.rewards[`${v}:1`] || []
            }
        },
    },
    watch: {
        creditTiers(value) {
            if (value?.length) {
                this.tab = value[0].id
            }
        },
        tab(value) {
            this.getTierRewardsByTierIndex(value)
        },
    },
    mounted() {
        if (this.creditTiers?.length) {
            this.tab = this.creditTiers[0].id
        }
    },
    methods: {
        findItemById(id) {
            if (!id) return null
            const findTier = this.creditTiers.find((el) => el.id === id)
            return findTier
        },
        getTierRewardsByTierIndex(tierIndexId) {
            if (!tierIndexId) return

            // If the rewards are already loaded, do not fetch again
            if (this.rewards[`${tierIndexId}:1`]) return

            this.$store.dispatch('activities/exchange-reward/getTierRewards', {
                reward_type: 1,
                tier_id: tierIndexId,
                currency: this.defaultCurrency,
            })
        },
    },
}
